import type { IconNode } from '../types';

/**
 * @name case-snake-upper
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMiAxNnYtNS41YTIuNSAyLjUgMCAwIDEgNSAwVjE2IiAvPgogIDxwYXRoIGQ9Ik03IDEzSDIiIC8+CiAgPHBhdGggZD0iTTExIDE2aDIiIC8+CiAgPHBhdGggZD0iTTE3IDEyaDNhMiAyIDAgMSAxIDAgNGgtM1Y4aDIuNWEyIDIgMCAwIDEgLjEgNCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/case-snake-upper
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const caseSnakeUpper: IconNode = [
  ['path', { d: 'M2 16v-5.5a2.5 2.5 0 0 1 5 0V16', key: 'hgrh77' }],
  ['path', { d: 'M7 13H2', key: '29ve54' }],
  ['path', { d: 'M11 16h2', key: '3xe00a' }],
  ['path', { d: 'M17 12h3a2 2 0 1 1 0 4h-3V8h2.5a2 2 0 0 1 .1 4', key: 'cutigu' }],
];

export default caseSnakeUpper;
